import React from 'react'

import clsx from 'clsx'
import * as Material from '@material-ui/core'
import { FormHelperText } from '@material-ui/core'
import { MenuItem, InputLabel, FormControl } from '@material-ui/core'

import './styles.scss'

const Select = props => {
  const handleChange = (e, { props: { value } }) => {
    const { array = [], nameValue, name } = props
    const event = {
      target: {
        name,
        value: value,
        item: array.find(item => item[nameValue] === value)
      }
    }
    props.handleChange(event)
  }

  let {
    label,
    error,
    value,
    nameValue,
    array = [],
    inputProps,
    helperText,
    nameText = nameValue
  } = props || {}

  const className = clsx('Select', { error })

  return (
    <FormControl className={className}>
      <InputLabel>{label}</InputLabel>
      <Material.Select
        value={value}
        onChange={handleChange}
        inputProps={inputProps}
        {...props}
      >
        {array.map((item, index) => (
          <MenuItem key={index} value={nameValue ? item[nameValue] : item}>
            {nameText ? item[nameText] : item}
          </MenuItem>
        ))}
      </Material.Select>
      <FormHelperText>{helperText}</FormHelperText>
    </FormControl>
  )
}

Select.defaultProps = {
  value: '',
  array: []
}

export default Select
